import { render } from "./CreateReview.vue?vue&type=template&id=0619eeb0"
import script from "./CreateReview.vue?vue&type=script&lang=js"
export * from "./CreateReview.vue?vue&type=script&lang=js"

import "./CreateReview.vue?vue&type=style&index=0&id=0619eeb0&lang=sass"
import "./CreateReview.vue?vue&type=style&index=1&id=0619eeb0&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__